import ComingSoon from "components/ComingSoon";
import React from "react";

const S3Storage = () => {
  return <ComingSoon />;
};

export default S3Storage;
